import { Page, View, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { APP_HOST } from '@utils/apiHooks';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface ClaimPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const ClaimPage = ({ event, footer }: ClaimPageProps) => {
  const { t } = useTranslation();

  const eventHomePageUrl = `${APP_HOST}/events/${event?.slug}`;
  const firstCitation = event.website_content?.citations?.[0] || '';

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.topRow,
        }}
      >
        <View style={{ width: '48%' }}>
          <Text style={styles.title}>{t('event-partners-section-title')}</Text>

          <View
            style={{
              ...globalStyles.lineBar,
              borderColor: event?.design?.themeColor ?? '#0F91AE',
              marginLeft: 0,
              marginTop: 30,
            }}
          ></View>

          <View style={{ ...styles.about }}>
            <Text>
              <Link
                src={eventHomePageUrl}
                style={{ color: '#27343d', textDecoration: 'none' }}
              >
                {event?.name}
              </Link>
              {t('business-partner-claim-page-text-1')}{' '}
              <Text style={{ fontWeight: 900 }}>
                {t('business-partner-claim-page-text-2', {
                  eventName: event?.name,
                })}
              </Text>
            </Text>
          </View>

          <Text style={styles.getReady}>
            {t('get-ready-for-event', { eventName: event?.name })}{' '}
          </Text>
        </View>
      </View>

      <View
        style={{
          ...styles.bottomRow,
          backgroundColor: event?.design?.themeColor,
        }}
      >
        {firstCitation?.citation && (
          <View style={styles.citationWrapper}>
            <Text style={{ ...styles.citation }}>
              {'“'} {firstCitation.citation ?? ''} {'”'}
            </Text>
            <View
              style={{
                ...globalStyles.lineBar,
                borderColor: 'white',
                marginLeft: 0,
              }}
            />

            <View style={styles.speakerWrapper}>
              <Text style={styles.subtitle}>
                {firstCitation?.first_name ?? ''}{' '}
                {firstCitation?.last_name ?? ''}
              </Text>
              <Text style={styles.subtitle}>
                {firstCitation?.jobtitle ?? ''}
              </Text>
            </View>
          </View>
        )}
      </View>

      <SafeImage
        style={styles.image1}
        src={
          'https://media.we-conect.com/images/pdf/partnerprospectus/claim_01.png'
        }
      />

      <SafeImage
        style={styles.image2}
        src={
          'https://media.we-conect.com/images/pdf/partnerprospectus/claim_02.png'
        }
      />

      <SafeImage
        style={styles.image3}
        src={
          'https://media.we-conect.com/images/pdf/partnerprospectus/claim_03.png'
        }
      />

      {footer}
    </Page>
  );
};

export default ClaimPage;
